export class FormValidationException extends Error {
  constructor(message: string = 'Form validation exception') {
    super(message);
    this.name = 'FormValidationException';

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FormValidationException);
    }
  }
}
